import { Box, Code, Globe, Database, Wrench, Layers } from 'lucide-react'
import { cn } from '@/lib/utils'

interface CategoryFilterProps {
  selected: string
  onChange: (category: string) => void
}

const categories = [
  { id: 'all', label: 'All Images', icon: Layers },
  { id: 'base', label: 'Base', icon: Box },
  { id: 'runtime', label: 'Runtime', icon: Code },
  { id: 'web', label: 'Web', icon: Globe },
  { id: 'database', label: 'Database', icon: Database },
  { id: 'tool', label: 'Tools', icon: Wrench },
]

export default function CategoryFilter({ selected, onChange }: CategoryFilterProps) {
  return (
    <div className="flex flex-wrap gap-2">
      {categories.map(cat => {
        const Icon = cat.icon
        const isSelected = selected === cat.id

        return (
          <button
            key={cat.id}
            onClick={() => onChange(cat.id)}
            className={cn(
              'flex items-center gap-2 px-3 py-2 rounded-lg text-sm font-medium transition-colors',
              isSelected
                ? 'bg-primary-600 text-white'
                : 'bg-dark-800 text-dark-300 hover:text-white hover:bg-dark-700'
            )}
          >
            <Icon className="h-4 w-4" />
            {cat.label}
          </button>
        )
      })}
    </div>
  )
}
